import { useMemo, useRef } from "react";
import ReactQuill from "react-quill-new";
import Quill from "quill";
import "react-quill-new/dist/quill.snow.css";
import { toast } from "sonner";
import api from "../api";

const Link = Quill.import("formats/link");
class ExternalLink extends Link {
  static create(value) {
    const node = super.create(value);
    node.setAttribute("target", "_blank");
    node.setAttribute("rel", "noopener noreferrer");
    return node;
  }
}
Quill.register(ExternalLink, true);

export function RichTextEditor({ value, onChange, placeholder }) {
  const quillRef = useRef(null);

  const imageHandler = () => {
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();
    input.onchange = async () => {
      const file = input.files?.[0];
      if (!file) return;
      const fd = new FormData();
      fd.append("file", file);
      try {
        const { data } = await api.post("/media/upload", fd);
        const editor = quillRef.current.getEditor();
        const range = editor.getSelection(true);
        editor.insertEmbed(range.index, "image", data.url);
        editor.setSelection(range.index + 1);
      } catch {
        toast.error("Image upload failed");
      }
    };
  };

  const modules = useMemo(() => ({
    toolbar: {
      container: [
        [{ header: [1, 2, 3, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["blockquote", "code-block"],
        ["link", "image"],
        ["clean"],
      ],
      handlers: { image: imageHandler },
    },
  }), []);

  const formats = ["header", "bold", "italic", "underline", "strike", "list", "blockquote", "code-block", "link", "image"];

  return (
    <div className="ig-quill" data-testid="rich-text-editor">
      <ReactQuill ref={quillRef} theme="snow" value={value || ""} onChange={onChange} modules={modules} formats={formats} placeholder={placeholder} />
    </div>
  );
}
